<template>
    <div>
        <div class="row">
            <div class="col text-right">
                <div class="po-actions mb-3" v-if="showButtons">
                    <b-button
                        variant="outline-primary"
                        class="ml-2"
                        @click="dummySave()"
                    >
                        <b-spinner small v-show="dummySaving"></b-spinner>
                        {{ $t("save_quit") }}
                    </b-button>
                    <orders-send-multiple
                        @success="showSuccess"
                        @error="showError"
                        :orders="ordersArr"
                        class="ml-2"
                    ></orders-send-multiple>
                </div>
            </div>
        </div>

        <orders-purchase-order
            modal-id="new_purchase_order"
            :admin-mode="isAdmin"
            :need-redirect="false"
        ></orders-purchase-order>

        <div v-for="(order, index) in ordersArr" :key="order.po_number">
            <orders-purchase-order
                :modal-id="'purchase_order_' + order.id"
                :order="order"
                :admin-mode="isAdmin"
                :need-redirect="false"
                :is-update="false"
                @saved="reloadOrder(order.id, index)"
            ></orders-purchase-order>
            <div class="purchase-order-widgets">
                <b-card no-body class="mb-3">
                    <template v-slot:header>

                        <div class="d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">
                                {{ $t("Purchase Order") }} {{ order.po_number }}
                            </h5>
                            <div class="d-flex">
                                <b-button
                                class="mr-2"
                                @click="$bvModal.show('purchase_order_' + order.id)"
                                variant="outline-primary"
                                >
                                    <font-awesome-icon :icon="['fas', 'pen']" />
                                    {{ $t("Edit") }}
                                </b-button>
                                <b-button @click="deleteItem(order, index)" variant="danger">
                                    Delete
                                </b-button>
                            </div>
                        </div>

                        <div class="d-flex flex-row align-items-center">
                            <b-row class="align-items-center m-4" align-h="between">
                                <b-col class="d-flex flex-column justify-content-center" style="width: 200px" md="6">
                                    <strong>{{ $t("Order Date") }}</strong>
                                    {{ order.order_date }}
                                </b-col>
                                <b-col class="d-flex flex-column justify-content-center" style="width: 200px" md="6">
                                    <div class="p-2 border border-info rounded-lg text-center d-flex flex-column justify-content-center">
                                        <div class="font-weight-bold">
                                            <font-awesome-icon class="mx-1 text-info" icon="calendar-alt"></font-awesome-icon>
                                            {{ $t("Due Date") }}
                                        </div>
                                        <div>
                                            {{ order.due_date }}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>

                            <div class="d-flex justify-content-end w-100">
                                <b-list-group class="d-flex flex-row m-auto" flush>
                                    <b-list-group-item style="background-color: transparent; width: 300px;">
                                        <h5 class="text-muted">{{ $t("From") }}</h5>
                                        {{ order.client.name }} <br />
                                        {{ order.client.address }} <br />
                                        {{ order.client.city }}
                                    </b-list-group-item>

                                    <b-list-group-item style="background-color: transparent; width: 300px;">
                                        <h5 class="text-muted">{{ $t("To") }}</h5>
                                        {{ order.manufacturer.name }} <br />
                                        {{ order.manufacturer.address }} <br />
                                        {{ order.manufacturer.city }}
                                    </b-list-group-item>

                                    <b-list-group-item v-if="order.final_client" style="background-color: transparent; width: 170px;">
                                        <h5 class="text-muted">{{ $t("Final Client") }}</h5>
                                        {{ order.final_client }}
                                    </b-list-group-item>
                                </b-list-group>
                            </div>
                        </div>
                    </template>

                    <div class="card-body" style="min-height: 150px">
                        <div class="order-table-container">
                            <orders-order-table-edit
                                :passed_order="order"
                                :order-id="String(order.id)"
                                :report-input="String(order.id)"
                                :is_serial="order.is_serial_number"
                            ></orders-order-table-edit>
                        </div>
                    </div>

                    <template v-slot:footer>
                        <div v-if="order.status === 'draft'">
                            {{ $t("Last saved") }}
                            {{ lastSaves[order.id] | moment("DD/MM/YYYY HH:mm:ss") }}
                        </div>
                    </template>
                </b-card>
            </div>
        </div>

        <div class="col text-center">
            <b-button
                v-if="isAdmin || me.type === 'client'"
                @click="$bvModal.show('new_purchase_order')"
                variant="primary"
                @saved="checkOrders"
                class="btn-round"
            >
                <font-awesome-icon :icon="['fas', 'plus']" />
                Add purchase order
            </b-button>
        </div>

        <b-modal
            id="modal-error"
            size="sm"
            title="Something went wrong :("
            hide-footer
        >
            <template>
                <div class="d-flex justify-content-between flex-column">
                    <h6>{{ errorMessage }}</h6>
                    <b-button
                        class="mb-4 mt-3"
                        v-if="showUnlockButton"
                        @click="unlockPassports"
                    >
                        Unlock Passports
                    </b-button>
                    <h6>{{ errorMessagePartialSend }}</h6>
                </div>
            </template>
        </b-modal>

        <b-modal id="modal-success" size="sm" title="Success" hide-footer>
            <template>
                <div class="d-flex justify-content-between flex-column">
                    <h6>{{ successMessage }}</h6>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.order-table-container {
  display: flex;
}
</style>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import OrdersPurchaseOrder from "./PurchaseOrder";
import _ from "lodash";
import OrdersEditOrder from "./EditOrder";
import OrdersOrderTableEdit from "./OrderTableEdit";
import OrdersSendMultiple from "./SendMultiple";
import moment from "moment";

export default {
  name: "NewOrders",
  components: {
    OrdersSendMultiple,
    OrdersOrderTableEdit,
    OrdersPurchaseOrder
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      manufacturers: [],
      clients: [],
      loadingRows: [],
      statusOptions: [
        { text: this.$t("draft"), value: "draft" },
        { text: this.$t("Sent"), value: "sent" }
      ],
      ready: false,
      ordersArr: [],
      dummySaving: false,
      showButtons: false,
      lastSaves: [],
      errorMessage: "",
      errorMessagePartialSend: "",
      successMessage: "",
      showUnlockButton: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.purchaseOrders.loading,
      me: state => state.me.me
    })
  },
  mounted() {
    this.getMe().then(r => {
      this.ready = true;
      this.loadResources();
    });
    this.$root.$on("orderEmit", order => {
      axios
        .get(`/api/orders/${order.id}`)
        .then(response => {
          this.ordersArr.push(response.data.data);
          Vue.set(
            this.lastSaves,
            response.data.data.id,
            response.data.data.updated_at
          );
        })
        .finally(() => {
          this.checkOrders();
        });
    });

    this.$root.$on("newRowEmit", arr => {
      Vue.set(this.lastSaves, arr[0], arr[1].created_at);
    });
  },
  methods: {
    showSuccess(data) {
      this.successMessage = data.message;
      this.$bvModal.show("modal-success");

      setInterval(() => window.location.replace("/orders"), 3000);
    },
    showError(data) {
      this.errorMessage = data.message;

      if (data.errorCode == 1) {
        this.showUnlockButton = true;
      } else {
        this.showUnlockButton = false;
      }

      if (data.partialSent) {
        this.errorMessagePartialSend =
          "Some of your orders have been sent, and the passports generated. Go back to the order list page to manage orders that failed.";
      }

      this.$bvModal.show("modal-error");
    },
    unlockPassports() {
      window.open("https://www.ionaute.com/", "_blank");
      window.location.href = "/orders";
    },
    deleteItem(item, index) {
      this.deleteOrder(item.id).finally(() => {
        this.ordersArr.splice(index, 1);
        this.$set(this.loadingRows, item.index, false);
        this.checkOrders();
      });
    },
    loadResources() {
      if (this.mode !== "client") {
        this.getClients();
      }

      if (this.mode !== "manufacturer") {
        this.getManufacturers();
      }
    },
    getClients() {
      if (this.me.type === "client") {
        return;
      }

      let url =
        this.me.type === "manufacturer"
          ? `/api/manufacturers/${this.me.manufacturer.id}/clients`
          : "/api/clients";

      return axios.get(url).then(r => {
        this.clients = r.data.data.map(c => {
          return {
            value: c.id,
            text: c.name
          };
        });
      });
    },
    getManufacturers() {
      let url = this.isAdmin
        ? "/api/manufacturers"
        : `/api/clients/${this.me.client.id}/manufacturers`;
      return axios.get(url).then(r => {
        this.manufacturers = r.data.data.map(m => {
          return {
            value: m.id,
            text: m.name
          };
        });
      });
    },
    reloadOrder(orderId, index) {
      axios
        .get(`/api/orders/` + orderId)
        .then(response => {
          Vue.set(this.ordersArr, index, response.data.data);
          Vue.set(
            this.lastSaves,
            response.data.data.id,
            response.data.data.updated_at
          );
        })
        .finally(() => {
          this.checkOrders();
        });
    },
    dummySave() {
      this.dummySaving = true;
      setTimeout(() => {
        this.dummySaving = false;
        this.redirectToOrders();
      }, 800);
    },
    redirectToOrders() {
      window.location.href = "/orders";
    },
    checkOrders() {
      if (this.ordersArr.length > 0) {
        this.showButtons = true;
      } else {
        this.showButtons = false;
      }
    },
    ...mapActions({
      getOrders: "purchaseOrders/getOrders",
      deleteOrder: "purchaseOrders/deleteOrder",
      updatePagination: "purchaseOrders/updatePagination",
      updateSorting: "purchaseOrders/updateSorting",
      updateFilters: "purchaseOrders/updateFilters",
      getMe: "me/getMe",
      getOrder: "purchaseOrders/getOrder"
    })
  }
};
</script>

<style scoped>
</style>
